import * as React from 'react'
import { connect } from 'react-redux'

import Appversion from '../../screens/Appversion/Appversion'
import { appVrsnList,editAppversion } from './action'
class AppversionContainer extends React.Component<Props, State>{
    render() {
        return <Appversion
        appVrsnList={this.props.appVrsnList}
        appversionDtls={this.props.appversionDtls}
        editAppversion={this.props.editAppversion}
        />
    }
}
function bindAction(dispatch) {
    return {
        appVrsnList: () => {
           
            dispatch(appVrsnList())
        },
        editAppversion: (value) => {
           
            dispatch(editAppversion(value))
        },
       
    }
}
function mapStateToProps(state) {

    return {
        appversionDtls:state.AppversionReducer.appversionDtls
    }
  }

export default connect(mapStateToProps, bindAction)(AppversionContainer)